export const sortBy = (arr, propertyName) =>
  [...arr].sort((a, b) => {
    if (a[propertyName] < b[propertyName]) return -1;
    if (a[propertyName] > b[propertyName]) return 1;
    return 0;
  });
